import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "app-redaction-publish-date-cell-renderer",
  templateUrl: "./publish-date.cell-renderer.html",
})
export class RedactionPublishDateRenderer implements ICellRendererAngularComp {
  value: any;
  params: ICellRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = params.value;
  }

  refresh(params: ICellRendererParams): boolean {
    this.value = params.value;
    this.params = params;
    return true;
  }
}
